module.exports = __webpack_public_path__ + "static/media/aboutActiveIcon.f38751a0.svg";